import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'kt-persona-details-form',
  templateUrl: './persona-details-form.component.html',
  styleUrls: ['./persona-details-form.component.css']
})
export class PersonaDetailsFormComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
